import { ButtonTagColored } from "./Colored";
import { ButtonTagPlain } from "./Plain";

export { ButtonTagColored, ButtonTagPlain };
